import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly8A2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/8A/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/8A/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/8A/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/8A/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/8A/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/8A/6.webp`;


  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },
  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
                   Topic: ‘Ignite8: Flip the Script’
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class:- 8A      DATE: 20,22 and 24 August 2026
                </Typography>

        <Typography variant={'subtitle1'} align={'justify'}>
Class 8A conducted a three-part mini-TEDx assembly series titled ‘Ignite8: Flip the Script’ on 20, 22 and
24 August 2026. The assembly focussed on equipping students with practical, real-world tools to navigate
academic pressure and everyday school challenges.
<br></br>
Through live demonstrations, student presenters shared three key hacks. The first presenter shared ‘The
Attention Hack,’ showing how 25-minute Pomodoro study sprints can tackle procrastination. The second
presenter introduced ‘The Presence Hack,’ demonstrating how the ‘3-Second Freeze Frame’ helps
students handle stage blunders with calm and posture. Finally, the third presenter delivered ‘The Filter
Hack,’ offering a simple three-step mental checklist to spot fake news and clickbait online.
        <br></br>
        The series ended on an inspiring note, reminding everyone that taking charge of your day comes from
building small, smart habits rather than being perfect.
  <br></br>
        </Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
   ‘Small resets build big control—hack your focus, your posture and your mind.’
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 4C 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly8A2026;
